import * as RestClient from '../../utils/rest-service';
import Constants from '../../config/constants';

export const ACTION = {
  LIST: 'LIST_BUILDING_HEAT_PUMP',
  CREATE: 'ADD_BUILDING_HEAT_PUMP',
  EDIT: 'EDIT_BUILDING_HEAT_PUMP',
  DELETE: 'REMOVE_BUILDING_HEAT_PUMP',
  CLEAR_ERROR: 'CLEAR_ERROR_PROJECT',
};

export const listHeatPumpInBuilding = (pageSize, page, sorted, filtered, isPublic, buildingId) => {
  return {
    type: ACTION.LIST,
    payload: RestClient.request({
      method: 'get',
      url: Constants.API_PROJECT_HEAT_PUMP,
      params: {
        search: filtered,
        limit: pageSize,
        offset: pageSize * page,
        ordering: sorted
          ? sorted.map(sort => sort.desc ? `-${sort.id}` : sort.id ).join(',')
          : null,
        is_public: isPublic,
        building_id: buildingId,
      }
    })
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const addHeatPumpToBuilding = (heatPumpId, buildingId, quantity) => {
  const data = {
    heat_pump_id: heatPumpId,
    building_id: buildingId,
    quantity: quantity,
  };

  return {
    type: ACTION.CREATE,
    payload: RestClient.request({
      method: 'post',
      url: Constants.API_PROJECT_HEAT_PUMP,
      data,
    })
      .catch(err => Promise.reject(err.response.data)),
  };
};

export const editHeatPumpInBuilding = (buildingHeatPumpId, quantity) => {
  const data = {
    quantity,
  };

  return {
    type: ACTION.EDIT,
    payload: RestClient.request({
      method: 'patch',
      url: `${Constants.API_PROJECT_HEAT_PUMP}${buildingHeatPumpId}/`,
      data,
    }).catch(err => Promise.reject(err.response.data)),
  };
};

export const removeHeatPumpFromBuilding = (buildingHeatPumpId, buildingId) => {
  return {
    type: ACTION.DELETE,
    payload: RestClient.request({
      method: 'delete',
      url: `${Constants.API_PROJECT_HEAT_PUMP}${buildingHeatPumpId}/`,
    })
      .then(() => ({ id: buildingHeatPumpId, building_id: buildingId }))
      .catch(err => Promise.reject(err.response.data)),
  };
};



// WEBPACK FOOTER //
// ./src/redux/projects/project_heat_pump_actions.js